import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { deleteSCList, setDialog } from "../../Corp/CorpUser.Slice";

const DeleteSCList = () => {
  const dispatch = useAppDispatch();
  const { isOpen, data } = useAppSelector((state) => state.CorpDashboard.dialogs.deleteSCList);
  const handleClose = () => dispatch(setDialog({ dialogName: "deleteSCList", isOpen: false, data: {} }));
  const handleDelete = () => dispatch(deleteSCList(data?.id));

  return (
    <DialogFormation
      openDialog={isOpen}
      handleClose={handleClose}
      title="Delete List"
      actionConfig={
        <div className="modal-config-wrapper">
          <Button label="Cancel" variant="secondary" onClick={handleClose} />
          <Button variant="alert" label="Delete" onClick={handleDelete} />
        </div>
      }
    >
      <Grid container px={"16px"}>
        <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
          Deleting the
          <Box component="span" sx={{ color: tokens.Text.General.PrimaryHeadline, fontWeight: 600 }}>
            {" "}
            {data?.name}
          </Box>{" "}
          list removes all user info. This action can't be undone. Do you wish to proceed?
        </Typography>
      </Grid>
    </DialogFormation>
  );
};

export default DeleteSCList;
